import React from 'react';
import PropTypes from 'prop-types';
import './PlaylistHeader.styl';
import CoachingPlan from 'records/CoachingPlan';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import {PLAYLIST_VISIBILITY} from 'stores/CoachingPlaylistStore';
import ModifyReviewDialogContainer from 'components/coaching/ModifyReviewDialogContainer';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import AuthStore from 'stores/AuthStore';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import UserAvatar from 'components/pure/utils/UserAvatar';
import OverflowTooltip from 'components/pure/utils/OverflowTooltip';
import PlaylistTitleBar from 'components/coaching/PlaylistTitleBar';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

export default class PlaylistHeader extends React.PureComponent {
  state = {showModifyDialog: false};

  render() {
    const {title, plan, visibility, review, reviewCoach} = this.props;

    const sessionUser = AuthStore.getState().user;
    const isRecipient = plan?.recipient?.id === sessionUser.id;

    return (
      <div className="playlist-header">
        <PlaylistTitleBar
          title={title}
          closable
          visibility={visibility}
          onToggle={CoachingPlaylistActions.toggle}
          onHide={CoachingPlaylistActions.hide}
        />
        {plan && (
          <div className="avatar-and-plan-info">
            <UserAvatar user={plan.recipient.info} enableTooltip />
            <div className="plan-info">
              <OverflowTooltip tooltipText={plan.name}>
                <div className="plan">
                  Plan: <strong>{plan.name}</strong>
                </div>
              </OverflowTooltip>

              <div className="coach">Coach: {reviewCoach ? reviewCoach.getFullName() : ''}</div>
              {!isRecipient && <CogIcon onClick={() => this.setState({showModifyDialog: true})} />}
            </div>
          </div>
        )}
        <ModifyReviewDialogContainer
          open={this.state.showModifyDialog}
          refreshCoachingData={() => {
            // Refresh the user's agenda in the event the modifications affected one of them
            UpcomingReviewsActions.upcomingReviews(
              AuthStore.getState().user.id,
              UPCOMING_REVIEW_ROLES.COACH
            );
            CoachingPlanActions.retrieve(plan.id, {includeReviews: true});
          }}
          onRequestClose={() => this.setState({showModifyDialog: false})}
          review={review}
        />
      </div>
    );
  }
}

PlaylistHeader.propTypes = {
  title: PropTypes.string,
  plan: PropTypes.instanceOf(CoachingPlan),
  visibility: PropTypes.oneOf(Object.values(PLAYLIST_VISIBILITY)),
};
